import { useState } from "react";

interface CopyButtonProps {
  promptText: string;
}

export const CopyButton = ({ promptText }: CopyButtonProps) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyPrompt = async () => {
    if (isCopied) return;

    try {
      await navigator.clipboard.writeText(promptText);
      setIsCopied(true); 

      setTimeout(() => {
        setIsCopied(false);
      }, 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  return (
    <button
      className="inline-flex items-center justify-center gap-2 rounded-md border border-gray-700 bg-gray-800 px-2 py-2 text-sm font-medium text-white shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-gray-500 focus:ring-1 focus:ring-offset-gray-600 focus:ring-offset-2 transition-colors duration-300 cursor-pointer"
      onClick={handleCopyPrompt}
    >
      <div className="relative h-4 w-4 flex items-center justify-center">
        <ClipBoardIcon
          className={`absolute h-4 w-4 transition-all duration-300 ${
            isCopied ? "scale-0 opacity-0" : "scale-100 opacity-100"
          }`}
        />
        <CheckIcon
          className={`absolute h-4 w-4 text-green-400 transition-all duration-300 ${
            isCopied ? "scale-100 opacity-100" : "scale-0 opacity-0"
          }`}
        />
      </div>
    </button>
  );
};

const ClipBoardIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
  </svg>
);

const CheckIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);